
export const DELETE_EVENT="event/delete_event";
export const SET_EVENTS= "event/set_events";
export const ADD_EVENT="event/add_event";
export const UPDATE_EVENT="event/update_event";


export const SET_FORM="global/set_form";
export const UNSET_FORM="global/unset_form";
export const SET_USER="global/set_user";
export const UNSET_USER="global/unset_user";
export const SET_FILTERS="global/set_filters";
export const UNSET_FILTERS="global/unset_filters";



